module.exports = __webpack_public_path__ + "static/media/quietAchiever.bd4a4983.png";